// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 5: 初代教会
// ============================================================================
// レベル 53-65 (13レベル、39問)

export const chapter5Translations = {
  name: "初代教会",
  description: "力を受けます...",
  
  spiritualWisdom: {
    principle: "聖霊は証しをするための力と勇気を与える",
    scripture: "聖霊があなたがたの上に臨むとき、あなたがたは力を受けます。そして、わたしの証人となります (使徒の働き 1:8)",
    application: "教会は御霊の火の中に生まれ、勇気ある証しによって成長する"
  },
  
  levels: {
    53: {
      name: "昇天",
      challenge: "あなたがたはわたしの証人となります...地の果てにまで...",
      easy: {
        question: "イエスは復活から何日後に天に昇られましたか?",
        options: ["30日", "40日", "50日", "60日"],
        hint: "準備の聖書的な数",
        funFact: "☁️ 世界的宣教の前の40日間の集中的な教え!"
      },
      medium: {
        question: "イエスは天に昇る前にどんな約束をされましたか?",
        options: [
          "すぐに戻る",
          "力をもって聖霊を送る",
          "教会を建てる",
          "悪人を罰する"
        ],
        hint: "上からの力",
        funFact: "⚡ 聖霊の約束 - 恐れる弟子たちの変容!"
      },
      hard: {
        question: "昇天は私たちの霊的生活において何を象徴していますか?",
        options: [
          "イエスの存在の終わり",
          "イエスは天で支配し、私たちのために執り成される",
          "最終的な別れ",
          "象徴的な神話"
        ],
        hint: "それは栄光を受けた活発な存在についてです",
        funFact: "👑 イエスは神の右に座して支配し、私たちのために執り成されます!"
      }
    },
    
    54: {
      name: "ペンテコステ",
      challenge: "みな聖霊に満たされ、語り始めました...",
      easy: {
        question: "昇天から何日後にペンテコステが起こりましたか?",
        options: ["7日", "10日", "14日", "20日"],
        hint: "約十日",
        funFact: "🔟 10日間の熱心な祈りが御霊の注ぎの準備をする!"
      },
      medium: {
        question: "聖霊はどのような形で現れましたか?",
        options: [
          "激しい風のように",
          "炎のような舌のように",
          "鳩のように",
          "光のように"
        ],
        hint: "各弟子の上にとどまる炎",
        funFact: "🔥 炎のような舌: 御霊は勇気と異言の賜物を与える!"
      },
      hard: {
        question: "ペンテコステは普遍的な教会にとって何を表していますか?",
        options: [
          "孤立した歴史的出来事",
          "宣教教会の公式な誕生",
          "好奇心の奇跡",
          "祝祭の始まり"
        ],
        hint: "それは教会の出生証明書についてです",
        funFact: "🎂 ペンテコステ = 教会の誕生日、世界宣教の始まり!"
      }
    },

    55: {
      name: "ペテロの最初の説教",
      challenge: "私たちはどうしたらよいでしょうか、兄弟たち? 悔い改めなさい...",
      easy: {
        question: "ペテロの説教の後、何人がバプテスマを受けましたか?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "三千の魂",
        funFact: "🌊 一日で3000のバプテスマ - 並外れた霊的覚醒!"
      },
      medium: {
        question: "ペテロは群衆を何で責めましたか?",
        options: [
          "無知",
          "メシアであるイエスを十字架につけたこと",
          "信仰の欠如",
          "偽善"
        ],
        hint: "神の子に対する最高の罪",
        funFact: "⚔️ イエスを否定したペテロが、今その神性を宣言する!"
      },
      hard: {
        question: "ペテロの変容は聖霊の働きをどのように示していますか?",
        options: [
          "より教養を得る",
          "臆病で不安定から、勇敢で信仰に堅固になる",
          "力を得る",
          "人格が変わる"
        ],
        hint: "それは御霊による聖化についてです",
        funFact: "🗿 '揺れる葦'が'堅固な岩'になる - 変容の力!"
      }
    },

    56: {
      name: "最初の共同体",
      challenge: "彼らは使徒たちの教えと交わりに専念していました...",
      easy: {
        question: "最初のクリスチャンたちは財産をどのように分け合いましたか?",
        options: [
          "各自が自分のものを保持した",
          "すべてを共有していた",
          "金持ちだけが与えた",
          "法的義務によって"
        ],
        hint: "自発的な財産共有",
        funFact: "🤝 兄弟愛が非常に強烈で、自発的にすべてを分け合う!"
      },
      medium: {
        question: "最初のクリスチャンたちは何に時間を費やしましたか?",
        options: [
          "ビジネスのみ",
          "教え、交わり、パン裂き、祈り",
          "仕事のみ",
          "余暇"
        ],
        hint: "共同生活の四つの柱",
        funFact: "⛪ 教え、交わり、聖餐、祈り - 教会の基礎!"
      },
      hard: {
        question: "なぜこの最初の共同体はそれほど魅力的だったのですか?",
        options: [
          "裕福だった",
          "本物の愛と喜びが彼らの一致から輝いていた",
          "奇跡を約束した",
          "他者を批判した"
        ],
        hint: "それは生きた愛の証しについてです",
        funFact: "✨ '見よ、彼らがどのように愛し合っているか!' - 言葉以上に説得力のある証し!"
      }
    },

    57: {
      name: "足なえの癒し",
      challenge: "銀や金はわたしにはない。しかし、わたしにあるものをあげよう...",
      easy: {
        question: "その男はどのくらい足なえでしたか?",
        options: [
          "20年間",
          "30年間", 
          "生まれつき",
          "10年間"
        ],
        hint: "生まれつきの障害",
        funFact: "🚶 40年間の障害がイエスの名によって即座に癒された!"
      },
      medium: {
        question: "ペテロは誰の名によって足なえを癒しましたか?",
        options: [
          "神の名によって",
          "ナザレのイエス・キリストの名によって",
          "自分の名によって",
          "アブラハムの名によって"
        ],
        hint: "すべての名にまさる名",
        funFact: "✊ イエスの名は使徒たちを通して奇跡を行い続ける!"
      },
      hard: {
        question: "この癒しは福音にとって何を象徴していますか?",
        options: [
          "単純な医学的奇跡",
          "イエスがもたらす完全な救い: 霊的かつ肉体的",
          "使徒たちの力",
          "貧しい人々への慈善"
        ],
        hint: "それは人間の完全な救いについてです",
        funFact: "🩺 イエスは魂と体を癒す - 人の完全な救い!"
      }
    },

    58: {
      name: "迫害の始まり",
      challenge: "人に従うより、神に従うべきです...",
      easy: {
        question: "足なえの癒しの後、誰がペテロとヨハネを逮捕しましたか?",
        options: [
          "ローマ人",
          "サドカイ人と祭司たち",
          "民衆",
          "ピラト"
        ],
        hint: "ユダヤ教の宗教当局",
        funFact: "⛓️ 最初の宗教的迫害 - 福音が既存体制を乱す!"
      },
      medium: {
        question: "当局は使徒たちに何を禁じましたか?",
        options: [
          "エルサレムを離れること",
          "イエスの名によってこれ以上教えないこと",
          "これ以上奇跡を行わないこと",
          "これ以上祈らないこと"
        ],
        hint: "説教の禁止",
        funFact: "🚫 真理を沈黙させようとする - 福音を止めることは不可能!"
      },
      hard: {
        question: "使徒たちは禁止にどう反応しましたか?",
        options: [
          "恐れて従った",
          "人に従うより神に従うべきだと断言した",
          "交渉した",
          "逃げた"
        ],
        hint: "それは人間の法律より高い忠誠についてです",
        funFact: "⚖️ 神に従うための市民的不服従 - 確信の勇気!"
      }
    },

    59: {
      name: "アナニヤとサッピラ",
      challenge: "あなたは人を欺いたのではなく、神を欺いたのです...",
      easy: {
        question: "アナニヤとサッピラはどんな嘘をつきましたか?",
        options: [
          "何も売っていなかった",
          "一部を取っておきながら全額を与えたと言った",
          "貧しかった",
          "結婚していなかった"
        ],
        hint: "与えた金額についての嘘",
        funFact: "💰 一部を取っておくことは許されていた、捧げ物について嘘をつくことは許されない!"
      },
      medium: {
        question: "嘘の後、彼らに何が起こりましたか?",
        options: [
          "赦された",
          "突然死んだ",
          "追放された",
          "悔い改めた"
        ],
        hint: "即座の厳しい罰",
        funFact: "⚱️ 生まれたばかりの教会の純粋さを保つための厳しい裁き!"
      },
      hard: {
        question: "なぜ教会の初めにこれほど厳しい罰があったのですか?",
        options: [
          "神が残酷だった",
          "共同体に求められる聖さを確立するため",
          "恐れさせるため",
          "偶然"
        ],
        hint: "それは霊的誠実さを保つことについてです",
        funFact: "🔥 聖さの文化を確立するために初めに高い基準!"
      }
    },

    60: {
      name: "七人の執事",
      challenge: "あなたがたの中から評判の良い七人の人を選びなさい...",
      easy: {
        question: "何人の執事が選ばれましたか?",
        options: ["5", "6", "7", "12"],
        hint: "完全性の数",
        funFact: "7️⃣ 奉仕のための七人の執事 - 教会の神的組織!"
      },
      medium: {
        question: "彼らの主な役割は何でしたか?",
        options: [
          "福音を宣べ伝えること",
          "食卓で仕え、やもめたちを助けること",
          "新しい改宗者にバプテスマを授けること",
          "財政を管理すること"
        ],
        hint: "社会的および物質的な奉仕",
        funFact: "🍽️ 食卓の奉仕 = 最初のキリスト教慈善組織!"
      },
      hard: {
        question: "この組織は奉仕についてのキリスト教的ビジョンについて何を明らかにしていますか?",
        options: [
          "物質的な仕事は劣っている",
          "霊的奉仕と物質的奉仕は両方とも聖なるもの",
          "聖なるものと世俗的なものを分けなければならない",
          "祭司だけが真に仕える"
        ],
        hint: "それはあらゆる愛の奉仕の聖性についてです",
        funFact: "✨ 説教と同じ尊厳で食卓に仕える - あらゆる奉仕は聖なるもの!"
      }
    },

    61: {
      name: "ステパノ、最初の殉教者",
      challenge: "主よ、この罪を彼らに負わせないでください! こう言って眠りについた...",
      easy: {
        question: "ステパノの教会での役割は何でしたか?",
        options: ["使徒", "執事", "祭司", "預言者"],
        hint: "仕えるために選ばれた七人の一人",
        funFact: "✨ ステパノ: 執事が力強い伝道者と最初の殉教者になった!"
      },
      medium: {
        question: "ステパノはユダヤ人の指導者たちを何で非難しましたか?",
        options: [
          "腐敗",
          "常に聖霊に逆らってきたこと",
          "偽善",
          "貪欲"
        ],
        hint: "神への歴史的抵抗",
        funFact: "📜 ステパノは歴史を要約する: 神に対する絶え間ない反逆!"
      },
      hard: {
        question: "ステパノはどのように死に、彼の態度は何を明らかにしていますか?",
        options: [
          "処刑者への怒りの中で",
          "十字架上のイエスのように赦して",
          "絶望の中で",
          "敵を呪って"
        ],
        hint: "それはキリストの完全な模倣についてです",
        funFact: "💝 処刑者の赦し: ステパノはイエスの態度を完璧に再現する!"
      }
    },

    62: {
      name: "ピリポとエチオピアの宦官",
      challenge: "だれかが説明してくれなければ、どうして分かるでしょう?",
      easy: {
        question: "宦官は馬車で何を読んでいましたか?",
        options: [
          "詩篇",
          "預言者イザヤ",
          "創世記",
          "箴言"
        ],
        hint: "メシアの受難の預言者",
        funFact: "📖 イザヤ53章 - 誠実な探求者によって読まれたイエスについての完璧な預言!"
      },
      medium: {
        question: "ピリポはイザヤの箇所をどのように説明しましたか?",
        options: [
          "古代の歴史について語った",
          "このテキストからイエスを宣べ伝えた",
          "神学の授業を行った",
          "解釈を批判した"
        ],
        hint: "聖書は自然にキリストに導く",
        funFact: "✝️ すべての聖書がイエスに収束する - 理解の鍵!"
      },
      hard: {
        question: "エチオピアの宦官の改宗は何を象徴していますか?",
        options: [
          "孤立した改宗",
          "すべての人種と状態のための福音の普遍性",
          "特定の民族の優位性",
          "特別なケース"
        ],
        hint: "それは諸国民への開放についてです",
        funFact: "🌍 エチオピア人、宦官、大臣: 福音はすべての障壁を打ち破る!"
      }
    },

    63: {
      name: "タルソのサウロの回心",
      challenge: "サウロ、サウロ、なぜわたしを迫害するのか?",
      easy: {
        question: "サウロは回心前に何をしていましたか?",
        options: [
          "福音を宣べ伝えていた",
          "クリスチャンを迫害していた",
          "中立だった",
          "勉強だけしていた"
        ],
        hint: "弟子たちの激しい敵",
        funFact: "⚔️ サウロはイエスの弟子たちに対する脅迫と殺害の息を吹いていた!"
      },
      medium: {
        question: "イエスはサウロにどの道で現れましたか?",
        options: [
          "エルサレムへの道",
          "ダマスコへの道",
          "ガザへの道",
          "アンティオキアへの道"
        ],
        hint: "シリアの都市",
        funFact: "🛤️ ダマスコへの道 = 歴史上最も有名な変容の場所!"
      },
      hard: {
        question: "この回心は神の恵みをどのように示していますか?",
        options: [
          "神は善人だけを改宗させる",
          "恵みは最悪の敵を最大の使徒に変えることができる",
          "回心は当然のものだった",
          "サウロはすでに神に近かった"
        ],
        hint: "それは恵みの変容の力についてです",
        funFact: "⚡ 最大の迫害者から最大の宣教師へ - 恵みの奇跡!"
      }
    },

    64: {
      name: "ペテロとコルネリオ",
      challenge: "神は人をえこひいきされないことが、本当によく分かりました...",
      easy: {
        question: "コルネリオの職業は何でしたか?",
        options: [
          "商人",
          "ローマの百人隊長",
          "祭司",
          "律法学者"
        ],
        hint: "ローマ軍の将校",
        funFact: "🎖️ 公式に改宗した最初の異邦人 - 非ユダヤ人への開放!"
      },
      medium: {
        question: "ペテロはコルネリオに会う前にどんな幻を見ましたか?",
        options: [
          "天使が話しかけている",
          "きよい動物ときよくない動物のある布",
          "イエスが現れる",
          "破壊された神殿"
        ],
        hint: "きよさときよくないことについての幻",
        funFact: "🕊️ 動物のある布: 神は食物と人種の区別を廃止する!"
      },
      hard: {
        question: "この回心はどんな革命的原則を確立しましたか?",
        options: [
          "ローマ人が優れている",
          "神は人をえこひいきされない - 普遍的救い",
          "伝統を捨てなければならない",
          "割礼は無用"
        ],
        hint: "それは救いの普遍性についてです",
        funFact: "🌍 霊的革命: 福音は例外なくすべての民のためのもの!"
      }
    },

    65: {
      name: "アンティオキアの教会",
      challenge: "アンティオキアで弟子たちは初めてキリスト者と呼ばれた...",
      easy: {
        question: "アンティオキアで弟子たちは初めて何と呼ばれましたか?",
        options: ["弟子", "キリスト者", "信者", "聖徒"],
        hint: "今日でも私たちが持っている名前",
        funFact: "✝️ 'キリスト者' = '小さなキリスト' - 異邦人によって与えられた名誉の名!"
      },
      medium: {
        question: "バルナバと一緒にアンティオキアで教えるために誰が来ましたか?",
        options: [
          "ペテロ",
          "パウロ (サウロ)",
          "ヤコブ",
          "ヨハネ"
        ],
        hint: "使徒となった元迫害者",
        funFact: "👥 バルナバはタルソでパウロを探す - パウロの奉仕の始まり!"
      },
      hard: {
        question: "なぜアンティオキアはキリスト教の歴史でそれほど重要になったのですか?",
        options: [
          "裕福だった",
          "異邦人への最初の宣教センター",
          "良い場所にあった",
          "良い指導者がいた"
        ],
        hint: "それは宣教の拡大についてです",
        funFact: "🚢 アンティオキア: パウロのヨーロッパへのすべての宣教旅行の出発港!"
      }
    }
  }
};

export default chapter5Translations;
